import { defineStore } from 'pinia';
import { isEmpty } from '@/el-ui/libs/check.js';

export const useCurrencyStore = defineStore('currency',{
	
	state: () => {
		return { 
			current: {},
			currency: uni.$storage.get("currency","CNY")
		};
	},
	
	actions: {
		
		async getCurrent(){
			const { code, data } = await uni.$http.get("ucenter.currency/current");
			if(code == 1){
				this.current  = data;
				this.currency = data.code;
				uni.$storage.set("currency",data.code);
			}
			
			return data;
		},
		
		/**
		 * 获取货币符号
		 */
		getSymbolLeft(){
			if(isEmpty(this.current)){
				return "￥";
			}
			
			return this.current.symbol_left;
		},
		
		/**
		 * 获取汇率转换价格
		 */
		getExchangeRatePrice(value,options=null){
			if(isEmpty(this.current)){
				return value.toFixed(2);
			}
			
			return (value * this.current.value).toFixed(this.current.decimal_place);
		},
		
		setData(data){
			this.current  = data;
			this.currency = data.code;
			uni.$storage.set("currency",data.code);
		},
		
		getData(){
			if(uni.$storage.get("currency",null)){
				return uni.$storage.get("currency",null);
			}
			
			return this.currency;
		}
	}
	
});